<template>
  <div class="msg" :class="borderCls">
    <div class="msg-header">
      <i
        :title="
          equiIconConvert(infoObj.deviceCatalog, infoObj.param.type).title
        "
        :class="
          equiIconConvert(infoObj.deviceCatalog, infoObj.param.type).icon
        "
        class="icon-margin"
      ></i>
      <!-- <i :class="deviceTypeFn(infoObj.deviceCatalog, 'icon')" :title="deviceTypeFn(infoObj.deviceCatalog, 'title')" style="padding-right:5px"></i> -->
      <i
        class="el-icon-document cursor-pointer"
        :title="$t('integration.details')"
        @click="deviceDetail"
      ></i>
      <h2>
        {{
          infoObj.param.tagId || infoObj.param.name || infoObj.param.relayCode
        }}
      </h2>
      <i
        v-show="!isShowClose"
        class="el-icon-circle-close"
        @click="handleClose(infoObj)"
      ></i>
    </div>
    <div style="height:32px;overflow-y:auto;margin: 0 10px;margin-top: 5px;">
      <!-- 因为网关和显示屏是一对多个挂载 -->
      <template
        v-if="infoObj.deviceCatalog === 1 || infoObj.deviceCatalog === 2"
      >
        <div
          class="uk-flex uk-flex-between border1 "
          style="padding:8px 10px"
          v-if="infoObj.param.carrierName"
        >
          <span
            :title="infoObj.param.carrierNameList.join(',')"
            class="cursor-pointer ellipsis"
          >
            {{ infoObj.param.carrierNameList.join(',') }}</span
          >
          <span>
            <el-popover trigger="hover">
              <ul>
                <li v-for="item in infoObj.param.carrierFormatList">
                  <div class="uk-flex uk-flex-between uk-flex-middle">
                    <span>
                      <i v-icon="['carrierTypeConvert', item.type]"></i>
                      {{ item.name }}
                    </span>
                    <i
                      class="ml-5 el-icon-document cursor-pointer"
                      @click="toCarrierDetail(item)"
                    ></i>
                  </div>
                </li>
              </ul>
              <template #reference>
                <i class="el-icon-more-outline cursor-pointer"></i>
              </template>
            </el-popover>
          </span>
        </div>
        <div v-else class="border1 uk-text-center" style="padding:8px 10px">
          {{ $t('integration.unassociated_monitoring_points') }}
        </div>
      </template>

      <template v-else>
        <div
          class="uk-flex uk-flex-between border1 "
          style="padding:8px 10px"
          v-if="infoObj.param.carrierName"
        >
          <span :title="infoObj.param.fullPath" class="cursor-pointer">{{
            infoObj.param.carrierName
          }}</span>
          <span>
            <i
              class="el-icon-document cursor-pointer"
              @click="toCarrierDetail"
              :title="$t('integration.details')"
            ></i>
          </span>
        </div>
        <div v-else class="border1 uk-text-center" style="padding:8px 10px">
          {{ $t('integration.unassociated_monitoring_points') }}
        </div>
      </template>
    </div>

    <div class="msg-middle">
      <div
        class="msg-image"
        :class="infoObj.param.configStatus === 1 ? '' : 'msg-image-not-beofre'"
      >
        <img :src="infoObj.param.pictureBase64" alt="" srcset="" />
      </div>
      <div class="msg-info">
        <!-- 传感器布局之温度 -->
        <template v-if="infoObj.deviceCatalog === 0">
          <div :class="`uk-flex-1 top-info-${infoObj.deviceCatalog}`">
            <div class="header-info">
              {{ this.probeValue['temp'] ? $timetransition(this.probeValue['temp'].time) : '---'}}
            </div>
            <div class="main-info-sensor ">
              <p
                :class="
                  classtempFn(infoObj.param, 'maxTemp', 'minTemp', 'temp')
                "
              >
                {{ JsontempFn(infoObj.param.probeValue) || '---' }}
              </p>
              <span>{{
                zuiVal(infoObj.param, unit['temp'].name, 'minTemp', 'maxTemp')
              }}</span>
            </div>
          </div>
          <!-- 传感器布局之湿度 -->
          <div
            :class="`uk-flex-1 bottom-info-${infoObj.deviceCatalog}`"
            v-if="
              infoObj.param.type === 2 ||
                infoObj.param.type === 4 ||
                infoObj.param.type === 6
            "
          >
            <div class="header-info">
              {{ this.probeValue['hum'] ? $timetransition(this.probeValue['hum'].time) : '---'}}
            </div>
            <div class="main-info-sensor">
              <p :class="classtempFn(infoObj.param, 'maxHum', 'minHum', 'hum')">
                {{ JsonhumFn(infoObj.param.probeValue) }}
              </p>
              <!-- <span>{{ infoObj.param.minHum }}% ~ {{ infoObj.param.maxHum }}%</span> -->
              <span>{{
                zuiVal(infoObj.param, unit['hum'].name, 'minHum', 'maxHum')
              }}</span>
            </div>
          </div>
        </template>
        <!-- 网关布局 && 显示屏布局-->
        <template
          v-else-if="
            infoObj.deviceCatalog === 1 || infoObj.deviceCatalog === 2
          "
        >
          <div :class="`top-info-${infoObj.deviceCatalog}`">
            <div class="header-info">
              {{ $timetransition(infoObj.param.updateTime) }}
            </div>
            <div class="main-info-gateway-display">
              <ul>
                <template v-if="infoObj.param.slaveDeviceList.length > 0">
                  <li
                    v-for="item in infoObj.param.slaveDeviceList"
                    :key="item.deviceId"
                  >
                    <div>
                      <!-- 设备类型图标 -->
                      <i
                        :class="
                          equiIconConvert(item.deviceCatalog, item.deviceType)
                            .icon
                        "
                        :title="
                          equiIconConvert(item.deviceCatalog, item.deviceType)
                            .title
                        "
                      ></i>
                      <span>{{ item.deviceName }}</span>
                    </div>
                    <i
                      class="el-icon-tickets"
                      :title="$t('integration.details')"
                      @click="detailFn(item.deviceCatalog, item)"
                    ></i>
                  </li>
                </template>
                <div v-else class="mothing-class">
                  {{ $t('integration.no_associated_devices_found') }}
                </div>
              </ul>
            </div>
          </div>
        </template>
        <!-- 中继设备布局 -->
        <template v-else-if="infoObj.deviceCatalog === 3">
          <div :class="`top-info-${infoObj.deviceCatalog}`">
            <div class="header-info">
              {{ $timetransition(infoObj.param.updateTime) }}
            </div>
            <div class="main-info-delay">
              <span>
                <i :class="equiStatusConvert(infoObj.param.status).icon"></i>
              </span>
              <p>{{ $t(equiStatusConvert(infoObj.param.status).title) }}</p>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- bottom -->
    <div class="border1 uk-flex uk-flex-between carrier" style="margin-top:0px">
      <Tooltip
        :text="
          infoObj.param.description ||
            $t('integration.no_description_information')
        "
        style="width:370px"
      >
      </Tooltip>
    </div>
  </div>
</template>
<script>
import bus from '@/utils/bus.js'
import { SET_ICON_TITLE_FN } from '@/utils/iconMatch.js'
import { deviceType } from '@/utils/icon.js'
import { equiIconConvert, equiStatusConvert } from '@/utils/convert'
import { goNewWindows } from '@/utils/goNewWin.js'
import {
  carrierShareCarrierType,
  carrierShareParam
} from '@/api/modules/carrier.js'
import { carrierDetail } from '@/utils/winDetail'
import Tooltip from '@/pages/system/resource/components/tooltip.vue'
import { TempUtils } from '@/utils/TempUtil.js';
export default {
  components: {
    Tooltip
  },
  props: {
    infoObj: {
      type: Object,
      default: () => ({})
    },
    iconDetaiArray: {
      type: Array,
      default: () => []
    },
    // fromType:是从新首页引入的该组件还是原来的监测点菜单，因为首页改成异常时边框颜色要闪烁
    fromType: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      equiStatusConvert,
      equiIconConvert,
      // 是否是处于配置状态
      isConfigStatus: false,
      // 是否显示关闭icon
      isShowClose: true,
      carrierDetail
    }
  },
  computed: {
    borderCls () {
      const catalog = this.infoObj.deviceCatalog
      if(this.fromType === 'home'){
        // 数据异常闪烁红，离线闪烁黄，断电闪烁蓝
        if (this.isAbnormal(this.infoObj.param) && this.infoObj.param.status === 1) {
            return 'ab-border-red'
          }
        if (this.infoObj.param.status === 0) {
          return 'ab-border-yellow'
        }

      }else{
        // 首先检查是否停用
        if (this.infoObj.param.status === 2) {
          return 'stop-msg-border'
        } else if (catalog === 0) {
          // 只有传感器才需要判断
          if (this.isAbnormal(this.infoObj.param)) {
            return 'ab-msg-border'
          }
        } else {
          return ''
        }
      }
    },
    probeValue () {
      return this.infoObj.param.probeValue ? JSON.parse(this.infoObj.param.probeValue) : {}
    }
  },
  created () {
    this.isShowClose = this.fromType === 'home' ? true : this.$route.query.isShowClose
  },

  methods: {
    deviceDetail () {
      const device = this.infoObj.param

      switch (this.infoObj.deviceCatalog) {
        // 传感器
        case 0:
          bus.$emit('sensorParam', device.id, device.tagId)
          break
        // 网关
        case 1:
          bus.$emit('gatewayParam', device.id, device.name)
          break
        // 显示屏
        case 2:
          bus.$emit('displayParam', device.id, device.displayCode)
          break
        // 中继
        case 3:
          bus.$emit('relayParam', device.id, device.relayCode)
          break
      }
    },
    toCarrierDetail (carrier) {
      if (carrier.id) {
        carrierDetail(carrier.id, carrier.name, carrier.type)
      } else {
        carrierDetail(
          this.infoObj.param.carrierId,
          this.infoObj.param.carrierName,
          this.infoObj.param.carrierType
        )
      }
    },
    handleClose (row) {
      // this.$confirm(this.$t('integration.are_you_sure_about_this_operation?'), this.$t('public.prompt'), {
      //     confirmButtonText: this.$t('messageTitle.Yes'), // 确定按钮的文案
      //     cancelButtonText: this.$t('messageTitle.Cancel'), // 取消按钮的文案
      //     type: 'warning'
      // })
      //     .then(() => {
      // 抛出一个方法 取消左侧列表勾选 抛出一个方法给父级删除右侧
      bus.$emit('cancelCheck', row.param.id)

      // // 抛出一个方法给父级删除右侧
      // this.$emit('cancelCheck', row.param.id)
      // })
      // .catch(() => { });
    },
    deviceTypeFn (type, str) {
      return SET_ICON_TITLE_FN(String(type), str, deviceType)
    },
    // 最值序列化
    JsontempFn (row) {
      let str
      if (row) {
        const { temp } = JSON.parse(row)
        str = TempUtils.convertToCelsius(temp.val,this.unit.temp.name) + this.unit.temp.name
      }
      return str
    },
    JsonhumFn (row) {
      // console.log(row);
      let str
      if (row) {
        const { hum } = JSON.parse(row)
        str = hum.val + this.unit.hum.name
      }
      return str
    },
    // 温度是否异常
    classtempFn (row, max, min, str) {
      let val, obj
      if (row.probeValue) {
        obj = JSON.parse(row.probeValue).hum || {}
        if (str === 'temp') {
          obj = JSON.parse(row.probeValue).temp || {}
        }
        // 没有在值判定为无异常
        if (obj.val === undefined) {
          return ''
        }

        val = obj.val
        if (val > row[max]) {
          return 'higher-range'
        } else if (val < row[min]) {
          return 'lower-range'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    zuiVal (info, unit, min, max) {
      let str = ''
      if (info[min] && info[max]) {
        str = `${TempUtils.convertToCelsius(info[min],unit)}${unit} ~ ${TempUtils.convertToCelsius(info[max],unit)}${unit}`
      }
      return str
    },
    handleIcon (item, infoObj) {
      if (item.id === 3 && infoObj.deviceCatalog === 0) {
        const { param } = infoObj
        goNewWindows({
          path: '/historyData',
          query: {
            tagId: param.tagId,
            id: param.id,
            probeValue: param.probeValue ? param.probeValue : {},
            carrierName: param.carrierName || '',
            scopeName: param.scopeName,
            sensorWay: 'bind'
          }
        })
      }
      // 详情
      else if (item.id === 4) {
        const { param, deviceCatalog } = infoObj
        this.detailFn(deviceCatalog, param)
      }
    },
    detailFn (deviceCatalog, row = {}) {
      console.log(deviceCatalog, row)
      switch (String(deviceCatalog)) {
        case '0': {
          bus.$emit('sensorParam', row.deviceId, row.deviceName)
          break
        }
        case '1': {
          bus.$emit('gatewayParam', row.id, row.name)
          break
        }
        case '2': {
          bus.$emit('displayParam', row.id, row.name)
          break
        }
        case '3': {
          bus.$emit('relayParam', row.id, row.relayCode)
          break
        }
        default:
          break
      }
    },
    getGenerValueFn (array = [], obj) {
      array.forEach(item => {
        item.content = ''
        for (const newKey in obj) {
          item.key === newKey ? (item.content = obj[newKey]) : null
        }
      })
    },
    // 监测点详情
    async handleCarrier (row) {
      const { param } = row
      let typeCode
      switch (param.carrierType) {
        case 1: {
          typeCode = 'incubator'
          break
        }
        case 2: {
          typeCode = 'fridge'
          break
        }
        case 3: {
          typeCode = 'car'
          break
        }
        case 4: {
          typeCode = 'refrigeratory'
          break
        }
        default:
          break
      }
      const { result } = await carrierShareCarrierType({ typeCode })
      const { result: results } = await carrierShareParam({
        code: 'carrier_status_item',
        type: 0
      })
      console.log(result, results)
      sessionStorage.setItem('getCarrierStatus', JSON.stringify(results))
      sessionStorage.setItem('getCarrierType', JSON.stringify(result))
      goNewWindows(
        {
          path: '/newCarrierDetail',
          query: {
            // keycode: param['carrierName'],
            type: param.carrierType,
            id: param.carrierId
          }
        },
        false
      )
    },
    handledisCarrier (param) {
      goNewWindows(
        {
          path: '/newCarrierDetail',
          query: {
            // keycode: param['keycode'],
            type: param.typeId,
            id: param.id
          }
        },
        false
      )
    },
    isAbnormal (param) {
      if (
        this.classtempFn(param, 'maxTemp', 'minTemp', 'temp') === '' &&
        this.classtempFn(param, 'maxHum', 'minHum', 'hum') === ''
      ) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 边框颜色
$borderColor1: #cccccc;
// 异常边框
$borderColor2: rgba(255, 66, 66, 0.5);

// 停用边框
$border-stop: orange;
// 1px边框
$border1: 1px solid $borderColor1;

.msg {
  width: 400px;
  height: 310px;
  margin: 0 15px 15px 0;
  border-radius: 2px;
  border: 1px solid $borderColor1;
  box-sizing: border-box;

  .carrier {
    margin: 0px 10px;
    margin-top: 5px;
    padding: 8px 10px;
  }

  .msg-header {
    height: 29px;
    padding: 0 10px;
    border-bottom: 1px solid $borderColor1;
    display: flex;
    align-items: center;

    h2 {
      margin-right: 12px;
      flex: 1;
      font-weight: bold;
      text-align: center;
    }

    i {
      cursor: pointer;
      font-size: 14px;
    }
  }

  .msg-middle {
    height: 200px;
    display: flex;
    padding: 10px;
    box-sizing: border-box;

    .msg-image,
    .msg-info {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }

    .msg-image {
      border: 1px solid $borderColor1;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }

      &::before {
        content: '配置中';
        position: absolute;
        left: 0;
        top: 0;
        width: 60px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #fff;
        font-weight: bold;
        background-color: rgba($color: #ff0000, $alpha: 0.5);
      }
    }

    .msg-image-not-beofre {
      &::before {
        content: none;
      }
    }

    .msg-info {
      margin-left: 10px;
    }

    .top-info-0,
    .bottom-info-0,
    .top-info-1,
    .bottom-info-1,
    .top-info-2,
    .bottom-info-2,
    .top-info-3,
    .bottom-info-3 {
      height: 48%;
      border-radius: 2px;
      border: 1px solid $borderColor1;
      box-sizing: border-box;

      .header-info {
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-bottom: 1px solid $borderColor1;
        box-sizing: border-box;
      }
    }

    .top-info-0,
    .bottom-info-0 {
      .main-info-sensor {
        text-align: center;
        height: calc(100% - 30px);
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
          font-size: 18px;
          font-weight: bold;
          line-height: 38px;
        }
      }
    }

    .bottom-info-0 {
      margin-top: 4%;
    }

    .top-info-1,
    .bottom-info-1,
    .top-info-2,
    .bottom-info-2 {
      height: 100%;

      .main-info-gateway-display {
        height: calc(100% - 30px);

        ul {
          width: 100%;
          height: 100%;
          padding: 0 5px 0 10px;
          box-sizing: border-box;
          overflow: auto;

          li {
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-around;

            i {
              cursor: pointer;
            }
          }
        }

        .mothing-class {
          text-align: center;
          color: #cccccc;
          margin-top: 10px;
        }
      }
    }

    .top-info-3,
    .bottom-info-3 {
      height: 100%;

      .main-info-delay {
        height: calc(100% - 30px);
        width: 100%;
        display: flex;
        flex-direction: column;

        span {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        i {
          vertical-align: middle;
          text-align: center;
          font-size: 50px;
        }

        p {
          text-align: center;
          width: 100%;
          border-top: 1px solid $borderColor1;
          line-height: 40px;
        }
      }
    }
  }

  .msg-bottom {
    height: 160px;
    display: flex;
    // border: 1px solid $borderColor1;
    padding: 0 10px;
    box-sizing: border-box;

    .b-l-info {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      border: 1px solid $borderColor1;
      border-right: none;

      span {
        width: 56px;
        height: 56px;
        display: block;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          background-color: rgba(48, 78, 114, 0.3);
        }
      }

      i {
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;

        &:hover {
          color: #ff0000;
        }
      }
    }

    .b-r-info {
      flex: 2;
      border: 1px solid $borderColor1;
      border-left: none;
      padding: 10px;
      padding-left: 0;
      box-sizing: border-box;

      h3 {
        line-height: 20px;
        font-weight: 700;
      }

      .changeColor {
        &:nth-child(even) {
          background-color: #efefef;
        }
      }

      ul {
        height: calc(100% - 20px);
        width: 100%;
        overflow: auto;
      }

      li {
        line-height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-right: 5px;

        i {
          cursor: pointer;
        }
      }
    }
  }
}

// 异常边框
.ab-msg-border {
  border-color: $borderColor2;
  border-width: 2px;
}

// 停用边框
.stop-msg-border {
  border-color: $border-stop;
  border-width: 2px;
}

.border1 {
  border: 1px solid $borderColor1;
}
</style>
